import React from 'react';
import { motion } from 'framer-motion';
const images = [{
  src: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
  alt: 'Wedding ceremony under floral arch'
}, {
  src: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800&q=80',
  alt: 'Couple walking through vineyard'
}, {
  src: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80',
  alt: 'Elegant table setting with candles'
}, {
  src: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=800&q=80',
  alt: 'Wedding rings and floral details'
}, {
  src: 'https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=800&q=80',
  alt: 'Garden ceremony at golden hour'
}, {
  src: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80',
  alt: 'Joyful celebration moment'
}, {
  src: 'https://images.unsplash.com/photo-1544078751-58fee2d8a03b?w=800&q=80',
  alt: 'Grand ballroom reception'
}, {
  src: 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=800&q=80',
  alt: 'Estate at sunset'
}];
export function GalleryPreview() {
  return <section id="gallery" className="bg-warm-200 py-24 md:py-32" data-id="element-100">
      <div className="text-center mb-16 px-6" data-id="element-101">
        <span className="block text-copper text-xs font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-102">
          Gallery
        </span>
        <h2 className="font-serif text-4xl md:text-5xl text-charcoal" data-id="element-103">
          Moments Worth Remembering
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5 md:gap-2 px-1.5 md:px-2" data-id="element-104">
        {images.map((img, index) => <motion.div key={index} initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: index * 0.06
      }} className="relative overflow-hidden group aspect-[4/3]" data-id="element-105">
            <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-106" />
            <div className="absolute inset-0 bg-black/5 group-hover:bg-black/15 transition-colors duration-500" data-id="element-107" />
          </motion.div>)}
      </div>

      <div className="mt-16 text-center px-6" data-id="element-108">
        <a href="#full-gallery" className="inline-block px-8 py-4 border border-copper text-copper text-xs tracking-widest uppercase hover:bg-copper hover:text-white transition-colors duration-300" data-id="element-109">
          View Full Gallery
        </a>
      </div>
    </section>;
}